import { UserSchoolInfoDoesNotExistError } from "@seneca/schools-service-client";

import { throttledLogError } from "seneca-common/utils/apiStates";

export default function errorHandler(
  error: Error,
  {
    successAction,
    errorAction
  }: {
    successAction: (arg0?: any) => void;
    errorAction: (arg0?: any) => void;
  }
) {
  if (error instanceof UserSchoolInfoDoesNotExistError) {
    return successAction();
  }

  errorAction();
  throttledLogError(error);
}
